import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { openDemoMail, openPartnerMail } from '../lib/mailto';
export function FinalCTA() {
  return <section className="py-40 bg-zinc-950 relative overflow-hidden" data-id="element-26" data-mp="c6slrkigseef">
      {/* Ambient Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-white/5 rounded-full blur-[100px] pointer-events-none" data-id="element-27" data-mp="8571vf7iizuq" />

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10" data-id="element-28" data-mp="m3dnnwz6t9e1">
        <FadeIn data-id="element-29" data-mp="h4u4g4bzabpd">
          <h2 className="text-5xl md:text-7xl font-display font-medium text-white mb-8 leading-tight" data-id="element-30" data-mp="h5c7pkx25q6s">
            The Future of Property Inspections Is Already Here.
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-31" data-mp="qw6wavxs11ve">
          <Button variant="primary" className="w-full sm:w-auto text-lg px-8 py-4" onClick={openDemoMail} data-id="element-32" data-mp="14t3igk2y9v5y">
            Book a Demo
          </Button>
          <Button variant="secondary" className="w-full sm:w-auto text-lg px-8 py-4" onClick={openPartnerMail} data-id="element-33" data-mp="2c7107tri8hsr">
            Partner With Us
          </Button>
        </FadeIn>
      </div>
    </section>;
}